// extracted by mini-css-extract-plugin
export default {"wrapper":"detailtable_wrapper__Tlix4","table":"detailtable_table__zro4E","error":"detailtable_error__HFtXP"};